/* eslint-disable consistent-return */
import React, { useEffect, useRef } from 'react';
import { useEventListeners, useOutsideClick } from 'src/hooks/utils';
import ContainerOverlay from 'src/components/ui/ContainerOverlay/ContainerOverlay';
import { useOverlay } from 'src/providers/OverlayProvider';

type Props = {
  children: React.ReactNode;
};
const Overlay = ({ children }: Props) => {
  const mainRef = useRef<HTMLDivElement>(null);
  const { onClose } = useOverlay();
  const [isExpanded, setIsExpanded] = React.useState(false);

  useOutsideClick(mainRef, (e: MouseEvent) => {
    const nestedHandler = mainRef.current?.querySelector('[data-overlay-handles-outside="true"]');
    if (nestedHandler) return null;

    const event = e as MouseEvent;
    if (mainRef.current && !mainRef.current.contains(event.target as Node)) {
      onClose();
    }
  });

  useEventListeners([{ event: 'keydown' }], (event: Event) => {
    const nestedHandler = mainRef.current?.querySelector('[data-overlay-handles-escape="true"]');
    if (nestedHandler) return null;

    const e = event as KeyboardEvent;
    if (e.key === 'Escape') {
      onClose();
    }
  });

  useEffect(() => {
    if (mainRef.current) {
      setIsExpanded(true);
    }
  }, [mainRef]);

  return (
    <ContainerOverlay ref={mainRef} isExpanded={isExpanded}>
      {children}
    </ContainerOverlay>
  );
};

export default Overlay;
